import { FC } from "react";

export const BillsIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className || ""}`}
    >
      <mask
        id="mask0_4317_42579"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24"
      >
        <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4317_42579)">
        <path
          d="M14.5 13C13.6667 13 12.9583 12.7083 12.375 12.125C11.7917 11.5417 11.5 10.8333 11.5 10C11.5 9.16667 11.7917 8.45833 12.375 7.875C12.9583 7.29167 13.6667 7 14.5 7C15.3333 7 16.0417 7.29167 16.625 7.875C17.2083 8.45833 17.5 9.16667 17.5 10C17.5 10.8333 17.2083 11.5417 16.625 12.125C16.0417 12.7083 15.3333 13 14.5 13ZM7.5 16C6.95 16 6.47917 15.8042 6.0875 15.4125C5.69583 15.0208 5.5 14.55 5.5 14V6C5.5 5.45 5.69583 4.97917 6.0875 4.5875C6.47917 4.19583 6.95 4 7.5 4H21.5C22.05 4 22.5208 4.19583 22.9125 4.5875C23.3042 4.97917 23.5 5.45 23.5 6V14C23.5 14.55 23.3042 15.0208 22.9125 15.4125C22.5208 15.8042 22.05 16 21.5 16H7.5ZM9.5 14H19.5C19.5 13.45 19.6958 12.9792 20.0875 12.5875C20.4792 12.1958 20.95 12 21.5 12V8C20.95 8 20.4792 7.80417 20.0875 7.4125C19.6958 7.02083 19.5 6.55 19.5 6H9.5C9.5 6.55 9.30417 7.02083 8.9125 7.4125C8.52083 7.80417 8.05 8 7.5 8V12C8.05 12 8.52083 12.1958 8.9125 12.5875C9.30417 12.9792 9.5 13.45 9.5 14ZM20.5 20H3.5C2.95 20 2.47917 19.8042 2.0875 19.4125C1.69583 19.0208 1.5 18.55 1.5 18V7H3.5V18H20.5V20Z"
          fill="#007DFF"
        />
      </g>
    </svg>
  );
};
